import * as Yup from "yup";

export const addAccountSchema = Yup.object().shape({
  user_name: Yup.string()
    .min(4, "The clientname field must be at least 4 characters")
    .required("The clientname field is required"),
  display_name: Yup.string().required("The fullname field is required"),
  password: Yup.string()
    .min(8, "The password field must be at least 8 characters")
    .required("The password field is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), ""], "The confirm password field does not match")
    .required("The confirm password field is required"),
  role_id: Yup.string().required("Role ID is required"),
  role_name: Yup.string().required("Role name is required"),

  credit_reference: Yup.string()
    .matches(/^\d+$/, "Must be a valid number")
    .required("Credit Reference is required"),
  city: Yup.string().optional(),
  phone: Yup.string().optional(),

  member_max_exposure_amt: Yup.string().when("role_name", ([role_name], schema) => {
    if (role_name && role_name.toLowerCase() === "user") {
      return schema.required("Member max exposure amount is required").min(0, "Must be a positive number");
    }

    return schema.optional();
  }),

  commission_settings: Yup.object().shape({
    up_line: Yup.string()
      .matches(/^\d+$/, "Must be a valid number")
      .required("UpLine commission is required"),
    down_line: Yup.string()
      .matches(/^\d+$/, "Must be a valid number")
      .required("DownLine commission is required"),
    our: Yup.string().matches(/^\d+$/, "Must be a valid number").required("Our commission is required"),
  }),

  partnership: Yup.object().shape({
    up_line: Yup.string()
      .matches(/^\d+$/, "Must be a valid number")
      .required("UpLine partnership is required"),
    down_line: Yup.string()
      .matches(/^\d+$/, "Must be a valid number")
      .required("DownLine partnership is required"),
    our: Yup.string().matches(/^\d+$/, "Must be a valid number").required("Our partnership is required"),
  }),
  transaction_password: Yup.string().required("Transaction password is required"),

  member_min_bet: Yup.string().when("role_name", ([role_name], schema) => {
    if (role_name && role_name.toLowerCase() === "user") {
      return schema.matches(/^\d+$/, "Must be a valid number").required("Member minimum bet is required");
    }

    return schema.optional();
  }),
  member_max_bet_amt: Yup.string().when("role_name", ([role_name], schema) => {
    if (role_name && role_name.toLowerCase() === "user") {
      return schema.matches(/^\d+$/, "Must be a valid number").required("Member max bet amount is required");
    }

    return schema.optional();
  }),
  bet_delay: Yup.string().when("role_name", ([role_name], schema) => {
    if (role_name && role_name.toLowerCase() === "user") {
      return schema.matches(/^\d+$/, "Must be a valid number").required("Bet delay is required");
    }

    return schema.optional();
  }),
});

export const changePasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "The New Password field must be at least 8 characters long")
    .required("The New Password field is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), ""], "The Confirm Password confirmation does not match")
    .required("The Confirm Password field is required"),

  transaction_password: Yup.string().required("The Transaction Code field is required"),
});

export const resetPasswordSchema = Yup.object().shape({
  old_password: Yup.string().required("The Old Password field is required"),
  new_password: Yup.string()
    .required("The New Password field is required")
    .min(8, "The New Password field must be at least 8 characters long")
    .max(20, "The New Password field must be at most 20 characters long")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Password must contain at least one letter, one number, and one special character (@$!%*#?&)"
    ),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), ""], "The Confirm Password confirmation does not match")
    .required("The Confirm Password field is required"),
});
